import sourceEvent from "./sourceEvent";
import point from "./point";

export default function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/mouse.js
// module id = ../../../../d3-selection/src/mouse.js
// module chunks = 4